import React from "react";
import VenatusAd from "./VenatusAd";
import {
  VENATUS_DESKTOP_MULTISIZE_LEADERBOARD,
  VENATUS_DESKTOP_LEADERBOARD,
  VENATUS_MOBILE_LEADERBOARD,
  VENATUS_DESKTOP_INCONTENT,
  VENATUS_MOBILE_INCONTENT,
  VENATUS_DESKTOP_SIDE_RAIL,
} from "../utilities/constants";

const adDimensions = {
  [VENATUS_DESKTOP_MULTISIZE_LEADERBOARD]: { width: '970px', height: '250px' },
  [VENATUS_DESKTOP_LEADERBOARD]: { width: '728px', height: '90px' },
  [VENATUS_MOBILE_LEADERBOARD]: { width: '320px', height: '100px' },
  [VENATUS_DESKTOP_INCONTENT]: { width: '728px', height: '280px' },
  [VENATUS_MOBILE_INCONTENT]: { width: '336', height: '280px' },
  [VENATUS_DESKTOP_SIDE_RAIL]: { width: '336', height: '600px' },
};

export default class VenatusAdWithPlaceholder extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { placementId } = this.props;
    if (!placementId) {
      return null;
    }
    return (
      <div>
        <div
          style={{
            backgroundColor: "#FFFFFF",
            width: adDimensions[placementId].width,
            height: adDimensions[placementId].height,
            margin: "0 auto",
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ position: "absolute", textAlign: "center" }}>
            This website is supported by ads
          </div>
          <VenatusAd placementId={placementId} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ads/VenatusAdWithPlaceholder.js